(() => {
  const positions = new Map();
  class GwOptionCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gw-option-track]');
      this.controls = this.querySelector('.gw-option-controls');
      if (!this.track || !this.controls) return;
      this.prev = this.querySelector('[data-gw-option-prev]');
      this.next = this.querySelector('[data-gw-option-next]');
      this.key = this.closest('fieldset')?.getAttribute('data-option-id') || this.track.querySelector('input')?.name;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => {
        positions.set(this.key, this.track.scrollLeft);
        this.update();
      }, { ...options, passive: true });
      this.track.addEventListener('focusin', (event) => this.reveal(event.target.closest('label')), options);
      this.track.addEventListener('change', (event) => this.reveal(event.target.closest('label')), options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.mutations = new MutationObserver(() => this.update());
      this.mutations.observe(this.track, {childList: true, subtree: true});
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.track.scrollLeft = positions.get(this.key) || 0;
        this.reveal(this.track.querySelector('input:checked')?.closest('label'));
        this.update();
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.mutations?.disconnect();
    }
    move(direction) {
      this.track.scrollBy({left: direction * Math.max(140, this.track.clientWidth * .75), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    reveal(label) {
      if (!label) return;
      const item = label.getBoundingClientRect();
      const viewport = this.track.getBoundingClientRect();
      if (item.left < viewport.left) this.track.scrollLeft += item.left - viewport.left - 3;
      else if (item.right > viewport.right) this.track.scrollLeft += item.right - viewport.right + 3;
    }
    update() {
      const overflow = this.track.scrollWidth - this.track.clientWidth > 2;
      this.controls.hidden = !overflow;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
    }
  }
  if (!customElements.get('gw-option-carousel')) customElements.define('gw-option-carousel', GwOptionCarousel);
})();
